// Filter definitions shared by the hub and the chapter page.
export const isUnread = (a) => !a.viewer_state?.has_viewed;
export const isSaved = (a) => !!a.viewer_state?.is_bookmarked;

export const FILTERS = {
  all: { label: "All", test: () => true },
  new: { label: "New", test: (a) => !!a.is_new },
  unread: { label: "Unread", test: isUnread },
  saved: { label: "Bookmarked", test: isSaved },
};

export const countBy = (articles, key) => articles.filter(FILTERS[key].test).length;

export const formatEyebrowNumber = (n) => String(n).padStart(2, "0");
